import axios from "axios";

const getServerTime = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/server-time`);
        return response.data;
    } catch (error) {
        console.error("Error fetching server time:", error);
    }
};

export { getServerTime };

